import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FileText } from "lucide-react";
import type { EventEditorFormValues } from "../event.scheme";
import { renderError, RequiredLabel, SectionTitle, type CommonProps } from "./shared";

export function EventDetailsSection({ isSubmitting, canEditField }: CommonProps) {
  const { control } = useFormContext<EventEditorFormValues>();
  const { t } = useTranslation();
  return (
    <section className="event-form-section">
      <SectionTitle icon={<FileText className="h-4 w-4" />}>Event Details</SectionTitle>
      <RequiredLabel className="mb-2 block">{t("event.description")}</RequiredLabel>
      <Controller
        control={control}
        name="description"
        render={({ field, fieldState }) => (
          <>
            <textarea
              {...field}
              rows={5}
              maxLength={2000}
              className="min-h-32 w-full resize-y rounded-lg border border-input bg-background px-3 py-2 text-sm outline-none transition-shadow placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
              placeholder="Describe your event..."
              disabled={isSubmitting || !canEditField("description")}
            />
            {renderError(fieldState.error?.message)}
          </>
        )}
      />
    </section>
  );
}
